import { Component, OnDestroy, OnInit } from '@angular/core';
import { CorePageBaseComponent } from '../shared/core-page-base.component';

// tslint:disable: completed-docs
// tslint:disable: object-literal-sort-keys
@Component({
  selector: 'cu-dynamic-page',
  templateUrl: './dynamic-page.component.html'
})
export class DynamicPageComponent extends CorePageBaseComponent implements OnInit, OnDestroy {
  public ngOnInit(): void {}

  public ngOnDestroy(): void {}
}
